import React from 'react';
import { motion } from 'framer-motion';
import { useDrag } from 'react-use-gesture';
import { ArrowLeft } from 'lucide-react';
import { ChatWindow } from '../ChatWindow/ChatWindow';

const MobileChatWindow = ({ chat, onClose, onMinimize, onStartCall }) => {
    // Swipe down to close logic
    const bind = useDrag(({ movement: [mx, my], velocity, down, direction: [xDir, yDir] }) => {
        if (!down && my > 100 && yDir > 0.5) {
            onMinimize(chat.id); // Or close
        }
    });

    return (
        <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed inset-0 z-50 bg-white flex flex-col pb-safe-area-bottom"
            style={{ touchAction: 'none' }} // Prevent browser scroll interference for swipe
        >
            {/* Mobile Header Overlay - Replaces standard header or sits on top */}
            <div
                {...bind()}
                className="h-12 bg-purple-600 text-white flex items-center px-4 shrink-0 touch-pan-y"
            >
                <button onClick={() => onMinimize(chat.id)} className="mr-3">
                    <ArrowLeft size={24} />
                </button>
                <div className="flex-1 font-bold truncate">
                    {chat.name || 'Chat'}
                </div>
                {/* Swipe Indicator */}
                <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-12 h-1 bg-white/30 rounded-full" />
            </div>

            <div className="flex-1 overflow-hidden relative">
                <ChatWindow
                    activeChat={chat} // Renamed to activeChat
                    isFloating={false} // Full screen mode for internal logic
                    isMobile={true}
                    onStartCall={(isVideo) => {
                        if (onStartCall) {
                            onStartCall(chat.targetUserId || chat.id, isVideo ? 'video' : 'voice');
                        }
                    }}
                />
            </div>
        </motion.div>
    );
};

export default MobileChatWindow;
